export default __webpack_public_path__ + "static/media/3-1.f4a32061.jpg";